module.exports = __webpack_public_path__ + "static/img_4963-a133fa8de1f640b4e9b2c20190ff98e1.webp";